// extracted by mini-css-extract-plugin
export default {"loading":"progressiveImg_loading__DeelB","loaded":"progressiveImg_loaded__fwGe5"};